module.exports = __webpack_public_path__ + "img/11.017b2cbc.svg";